import {
  ItemDependencyStatus,
  isItemDependencyAtRisk,
  isItemDependencyBlocked,
} from '@/common/api/types/dashboard/health';
import {
  useItemHealth,
  useItemHealthById,
} from '@/features/insights-dashboard/queries/useItemHealth';
import { usePublishedContext } from '@/features/views/components/published/PublishedContext';

export const useItemProgressWithPublished = ({
  itemId,
  itemIds,
  enabled = true,
}: {
  itemId: number;
  itemIds: number[];
  enabled?: boolean;
}): {
  progressPercentage: number;
  dependencyStatus: ItemDependencyStatus | undefined;
  isLoading: boolean;
} => {
  const publishedContext = usePublishedContext();

  const { isLoading: isHealthLoading } = useItemHealth({
    itemIds,
    enabled: publishedContext === null && enabled,
  });
  const { data: itemHealthData } = useItemHealthById({
    itemId,
    enabled: publishedContext === null && enabled,
  });

  if (publishedContext !== null) {
    const panelData = publishedContext.getItemPanelData(itemId);
    return {
      progressPercentage: panelData?.progress ?? 0,
      dependencyStatus: undefined,
      isLoading: false,
    };
  }

  const dependencyStatus = itemHealthData
    ? isItemDependencyBlocked(itemHealthData)
      ? ItemDependencyStatus.BLOCKED
      : isItemDependencyAtRisk(itemHealthData)
        ? ItemDependencyStatus.AT_RISK
        : ItemDependencyStatus.NO_ISSUE
    : undefined;

  return {
    progressPercentage: Math.round(itemHealthData?.progress ?? 0),
    dependencyStatus,
    isLoading: isHealthLoading,
  };
};
